import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel.js';

const BASE = BaseModel.getApiBasePath() + '/api/v1/tinynode/parkingLocations';

export default new class TinyNodeParkinglocationsModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll() {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          ParkinglocationModel.getAll(true)
            .then((pl) => {
              let data = [];
              response.data.map(async (child, idx) => {
                let location = _.find(pl, { id: child.parkingLocationID });
                location
                  ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name, listenerName: "application/parking/" + child.parkingLocationID }))
                  : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/TinyNodeParkinglocationsModel.js